import axios from '@/helpers/http';

class AuthService {
  login(tc, pass) {
    return axios.post('giris', {
      kimlikNo: tc,
      sifre: pass
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  home_work(data) {
    return axios.post('sinav-listesi', {
      ogrenciID: data.student_id,
      durum: data.status
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
}

export default new AuthService();